import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { mascCoin } from "../../../../Helpers/Masc";
import { useMediaQuery } from "react-responsive";

export default function AccountReceivableInfo({ totalValues }) {
    const { t } = useTranslation();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return (
        <Row
            className={isMobile ? "financial-component-footer-mobile" : "financial-component-footer mb-4"}
        >
            <Col>
                <span className="footer-text-label">
                    {t("financial.accounts-receivable.info.total-receivable")}
                </span>
                <span
                    className="footer-text-values"
                    style={{ color: "#FFA900" }}
                >
                    {mascCoin(
                        totalValues?.total_to_receive,
                        t("currency.symbol"),
                        2,
                        t("currency.decimal"),
                        t("currency.thousands")
                    )}
                </span>
            </Col>
            <Col>
                <span className="footer-text-label">
                    {t("financial.accounts-receivable.info.total-discount")}
                </span>
                <span className="footer-text-values" style={{ color: "" }}>
                    {mascCoin(
                        totalValues?.total_discount,
                        t("currency.symbol"),
                        2,
                        t("currency.decimal"),
                        t("currency.thousands")
                    )}
                </span>
            </Col>
            <Col>
                <span className="footer-text-label">
                    {t("financial.accounts-receivable.info.total-cancelled")}
                </span>
                <span
                    className="footer-text-values"
                    style={{ color: "#F93154" }}
                >
                    {mascCoin(
                        totalValues?.total_cancelled,
                        t("currency.symbol"),
                        2,
                        t("currency.decimal"),
                        t("currency.thousands")
                    )}
                </span>
            </Col>
            <Col>
                <span className="footer-text-label">
                    {t("financial.accounts-receivable.info.total-paid")}
                </span>
                <span
                    className="footer-text-values"
                    style={{ color: "#00B74A" }}
                >
                    {mascCoin(
                        totalValues?.total_received,
                        t("currency.symbol"),
                        2,
                        t("currency.decimal"),
                        t("currency.thousands")
                    )}
                </span>
            </Col>
            <Col>
                <span className="footer-text-label">
                    {t("financial.accounts-receivable.info.total-value")}
                </span>
                <span className="footer-text-values" style={{ color: "" }}>
                    {mascCoin(
                        totalValues?.total_amount,
                        t("currency.symbol"),
                        2,
                        t("currency.decimal"),
                        t("currency.thousands")
                    )}
                </span>
            </Col>
        </Row>
    );
}
